<template>
  <div class="dc-dashboard-container">
    <basic-container>
      <div class="dc-dashboard-content">
        <div class="dc-dashboard-header">
          <div>
            <!-- <div class="dc-header-eyebrow">健康管理工作台 <span>/</span> 统计面板</div> -->
            <h1>数据概览</h1>
            <p>聚焦服务规模、健康风险与干预情况，掌握各项管理指标。</p>
          </div>
          <button type="button" class="dc-overview-button" @click="goToDataOverview">
            查看数据总览 <i class="el-icon-top-right" aria-hidden="true"></i>
          </button>
        </div>

        <section class="dc-summary-grid" aria-label="核心统计指标">
          <button
            v-for="item in summaryMetrics"
            :key="item.id"
            type="button"
            :class="['dc-summary-card', 'dc-tone-' + item.tone]"
            @click="goToDataOverview"
          >
            <div class="dc-summary-top">
              <span class="dc-metric-label">{{ item.label }}</span>
              <span class="dc-icon-box"><img :src="item.icon" alt="" /></span>
            </div>
            <div class="dc-summary-value">{{ formatNumber(item.value) }}<span>{{ item.unit }}</span></div>
            <div class="dc-summary-bottom">
              <span>{{ item.description }}</span>
              <i class="el-icon-right" aria-hidden="true"></i>
            </div>
          </button>
        </section>

        <div class="dc-detail-grid">
          <section v-for="group in metricGroups" :key="group.id" :class="['dc-panel', 'dc-' + group.id]">
            <div class="dc-panel-header">
              <div class="dc-section-icon"><i :class="group.icon" aria-hidden="true"></i></div>
              <div><h2>{{ group.title }}</h2><p>{{ group.description }}</p></div>
              <span class="dc-metric-count">{{ group.items.length }} 项指标</span>
            </div>
            <div class="dc-metric-list">
              <button
                v-for="item in group.items"
                :key="item.id"
                type="button"
                class="dc-metric-row"
                @click="goToDataOverview"
              >
                <span :class="['dc-row-icon', 'dc-tone-' + item.tone]"><img :src="item.icon" alt="" /></span>
                <span class="dc-row-content"><span class="dc-row-label">{{ item.label }}</span><span class="dc-row-description">{{ item.description }}</span></span>
                <span class="dc-row-value">{{ formatNumber(item.value) }}<small>{{ item.unit }}</small></span>
                <i class="el-icon-arrow-right dc-row-arrow" aria-hidden="true"></i>
              </button>
            </div>
            <div class="dc-panel-footer"><i class="el-icon-mouse" aria-hidden="true"></i> 点击指标查看数据总览</div>
          </section>

          <section class="dc-panel dc-comparison-panel">
            <div class="dc-panel-header">
              <div class="dc-section-icon"><i class="el-icon-data-analysis" aria-hidden="true"></i></div>
              <div><h2>服务规模对比</h2><p>各项人数直观呈现</p></div>
              <span class="dc-metric-count">单位：人</span>
            </div>
            <div class="dc-comparison-chart" role="list" aria-label="服务人数对比，条形长度按同一人数刻度展示">
              <button v-for="item in comparisonMetrics" :key="item.id" type="button" class="dc-comparison-item" @click="goToDataOverview">
                <span class="dc-comparison-label"><span>{{ item.label }}</span><strong>{{ formatNumber(item.value) }}</strong></span>
                <span class="dc-bar-track" aria-hidden="true"><span :class="['dc-bar-fill', 'dc-tone-' + item.tone]" :style="{ width: (item.value / comparisonMax * 100) + '%' }"></span></span>
              </button>
              <div class="dc-chart-scale" aria-hidden="true"><span>0</span><span>{{ formatNumber(comparisonMax / 2) }}</span><span>{{ formatNumber(comparisonMax) }}</span></div>
            </div>
            <div class="dc-comparison-note"><i class="el-icon-info" aria-hidden="true"></i><span>各指标按原有口径独立展示，人数可能交叉，不作合计。</span></div>
          </section>
        </div>
        <div class="dc-dashboard-footer"><span>健康管理 · 数据概览</span><span>选择任意指标，进一步查看详细统计</span></div>
      </div>
    </basic-container>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      userId: window.localStorage.getItem("pcUserId"),
      // 保留原面板的指标数值、单位及账号可见范围。
      metrics: [
        { id: "service", label: "服务总人数", value: 3255, unit: "人", group: "summary", tone: "teal", description: "服务覆盖规模", icon: require("@/page/login/images/count/6.png") },
        { id: "managed", label: "管理总人数", value: 662, unit: "人", group: "summary", tone: "blue", description: "健康管理规模", icon: require("@/page/login/images/count/5.png") },
        { id: "chronic", label: "慢病总人数", value: 3212, unit: "人", group: "summary", tone: "violet", description: "慢病人群规模", icon: require("@/page/login/images/count/3.png") },
        { id: "signed", label: "全科家医签约数", value: 512, unit: "人", group: "summary", tone: "amber", visibility: "general", description: "家庭医生签约服务", icon: require("@/page/login/images/count/4.png") },
        { id: "wearing", label: "佩戴设备人数", value: 3034, unit: "人", group: "summary", tone: "amber", visibility: "device", description: "设备佩戴规模", icon: require("@/page/login/images/count/11.png") },
        { id: "highRisk", label: "重疾高风险人数", value: 145, unit: "人", group: "risk", tone: "rose", description: "高风险人群统计", icon: require("@/page/login/images/count/2.png") },
        { id: "strokeRisk", label: "重疾中风风险人数", value: 1423, unit: "人", group: "risk", tone: "amber", description: "中风风险人群统计", icon: require("@/page/login/images/count/9.png") },
        { id: "qualified", label: "达标总人数", value: 562, unit: "人", group: "risk", tone: "teal", visibility: "general", description: "达标情况统计", icon: require("@/page/login/images/count/8.png") },
        { id: "unqualified", label: "未达标总人数", value: 962, unit: "人", group: "risk", tone: "amber", visibility: "general", description: "未达标情况统计", icon: require("@/page/login/images/count/7.png") },
        { id: "medication", label: "药物治疗人数", value: 567, unit: "人", group: "intervention", tone: "blue", description: "药物治疗服务", icon: require("@/page/login/images/count/1.png") },
        { id: "cognitive", label: "认知行为治疗人数", value: 1578, unit: "人", group: "intervention", tone: "violet", visibility: "general", description: "认知行为干预服务", icon: require("@/page/login/images/count/12.png") },
        { id: "agent", label: "专病智能体人数", value: 689, unit: "人", group: "intervention", tone: "teal", visibility: "general", description: "专病智能服务", icon: require("@/page/login/images/count/10.png") },
        { id: "consultation", label: "诊前咨询人数", value: 905, unit: "人", group: "intervention", tone: "blue", visibility: "general", description: "诊前咨询服务", icon: require("@/page/login/images/count/11.png") },
        { id: "alerts", label: "响应预警数量", value: 2695, unit: "次", group: "intervention", tone: "rose", visibility: "device", description: "预警响应统计", icon: require("@/page/login/images/count/4.png") },
      ],
    };
  },
  computed: {
    isDeviceAccount() {
      return this.userId === "2043870969731301377";
    },
    visibleMetrics() {
      return this.metrics.filter((item) => !item.visibility || item.visibility === (this.isDeviceAccount ? "device" : "general"));
    },
    summaryMetrics() {
      return this.visibleMetrics.filter((item) => item.group === "summary");
    },
    metricGroups() {
      return [
        { id: "risk", title: this.isDeviceAccount ? "健康风险" : "风险与达标", description: "关注人群健康状态", icon: "el-icon-first-aid-kit" },
        { id: "intervention", title: this.isDeviceAccount ? "干预与预警" : "干预与服务", description: "了解管理服务开展情况", icon: "el-icon-connection" },
      ].map((group) => ({ ...group, items: this.visibleMetrics.filter((item) => item.group === group.id) }));
    },
    comparisonMetrics() {
      return this.summaryMetrics.slice().sort((a, b) => b.value - a.value);
    },
    comparisonMax() {
      return Math.max(1000, Math.ceil(Math.max(...this.comparisonMetrics.map((item) => item.value)) / 1000) * 1000);
    },
  },
  methods: {
    formatNumber(value) {
      return value.toLocaleString("zh-CN");
    },
    goToDataOverview() {
      this.$router.push({ path: "/doctor/DataOverview" });
    },
  },
};
</script>

<style scoped lang="scss">
// 专属类名及普通容器标签，避免大屏页全局 .panel / header / footer 样式污染。
.dc-dashboard-container {
  width: 100%;
  min-width: 0;
  padding: 28px;
  box-sizing: border-box;
  background: #f3f6fa;
  color: #26354b;

  *, *::before, *::after { box-sizing: border-box; }
  .basic-container { height: auto; padding: 0; background: transparent; }
  ::v-deep .el-card { height: auto; overflow: visible; border: 0; background: transparent; box-shadow: none; }
  ::v-deep .el-card__body { padding: 0; }
  .dc-dashboard-content { max-width: 1800px; margin: 0 auto; }
  button { font: inherit; color: inherit; cursor: pointer; text-align: left; }
  button:focus-visible { outline: 3px solid #269d96; outline-offset: 3px; }
  .dc-dashboard-header { display: flex; justify-content: space-between; align-items: center; gap: 24px; margin-bottom: 26px; }
  .dc-header-eyebrow { color: #65778b; font-size: 12px; letter-spacing: 1px; }
  .dc-header-eyebrow span { margin: 0 10px; color: #bac5d0; }
  h1 { margin: 9px 0; font-size: 28px; line-height: 1.3; letter-spacing: 1px; font-weight: 600; }
  .dc-dashboard-header p { margin: 0; font-size: 13px; line-height: 1.7; color: #758397; }
  .dc-overview-button { display: flex; align-items: center; gap: 20px; flex-shrink: 0; border: 0; border-radius: 8px; padding: 13px 18px; background: #188b84; color: #fff; font-size: 13px; box-shadow: 0 4px 12px rgba(24,139,132,.14); }
  .dc-overview-button:hover { background: #137b75; }
  .dc-summary-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 18px; margin-bottom: 24px; }
  .dc-tone-teal { --accent: #188b84; --tint: #e9f6f3; }
  .dc-tone-blue { --accent: #417ccb; --tint: #edf4ff; }
  .dc-tone-violet { --accent: #8270c1; --tint: #f2effb; }
  .dc-tone-amber { --accent: #b78331; --tint: #fdf5e7; }
  .dc-tone-rose { --accent: #c86767; --tint: #fcefee; }
  .dc-summary-card { min-width: 0; border: 1px solid #e3eaf0; border-top: 3px solid var(--accent); border-radius: 12px; padding: 21px 22px 16px; background: #fff; box-shadow: 0 3px 10px rgba(34,60,80,.025); transition: box-shadow .2s, border-color .2s; }
  .dc-summary-card:hover { border-color: var(--accent); box-shadow: 0 8px 24px rgba(34,60,80,.08); }
  .dc-summary-top { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
  .dc-metric-label { color: #53647a; font-size: 14px; font-weight: 500; }
  .dc-icon-box { display: flex; align-items: center; justify-content: center; width: 46px; height: 46px; flex-shrink: 0; border-radius: 12px; background: var(--tint); }
  .dc-icon-box img { width: 30px; height: 30px; object-fit: contain; }
  .dc-summary-value { margin: 8px 0 17px; color: #23374d; font-size: 38px; font-weight: 600; font-variant-numeric: tabular-nums; line-height: 1.2; letter-spacing: .5px; }
  .dc-summary-value span { margin-left: 8px; font-size: 13px; font-weight: 400; color: #78879a; }
  .dc-summary-bottom { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding-top: 13px; border-top: 1px solid #eef2f6; font-size: 12px; color: #78879a; }
  .dc-summary-bottom i { color: var(--accent); font-size: 17px; }
  .dc-detail-grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, .95fr); gap: 20px; align-items: stretch; }
  .dc-panel { min-width: 0; display: flex; flex-direction: column; background: #fff; border: 1px solid #e3eaf0; border-radius: 12px; overflow: hidden; }
  .dc-panel-header { display: flex; align-items: center; gap: 10px; padding: 22px 20px; border-bottom: 1px solid #edf1f5; }
  h2 { margin: 0; font-size: 16px; line-height: 1.5; font-weight: 600; }
  .dc-panel-header p { margin: 4px 0 0; font-size: 12px; color: #78879a; line-height: 1.5; }
  .dc-section-icon { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; flex-shrink: 0; color: #188b84; background: #edf7f5; border-radius: 10px; font-size: 19px; }
  .dc-risk .dc-section-icon { background: #fdf5e7; color: #b78331; }
  .dc-comparison-panel .dc-section-icon { background: #edf4ff; color: #417ccb; }
  .dc-metric-count { margin-left: auto; white-space: nowrap; font-size: 11px; color: #7a8798; }
  .dc-metric-list { display: flex; flex-direction: column; flex: 1; padding: 0 16px; }
  .dc-metric-row { display: flex; align-items: center; gap: 12px; flex: 1; width: 100%; min-height: 87px; padding: 16px 4px; border: 0; border-bottom: 1px solid #f0f3f6; background: transparent; }
  .dc-metric-row:last-child { border-bottom: 0; }
  .dc-metric-row:hover { background: #f7fafc; }
  .dc-row-icon { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 38px; height: 38px; border-radius: 10px; background: var(--tint); }
  .dc-row-icon img { width: 26px; height: 26px; object-fit: contain; }
  .dc-row-content { display: flex; flex-direction: column; gap: 7px; flex: 1; min-width: 0; }
  .dc-row-label { font-size: 13px; line-height: 1.5; }
  .dc-row-description { font-size: 11px; line-height: 1.4; color: #8591a1; }
  .dc-row-value { flex-shrink: 0; font-size: 22px; font-weight: 600; font-variant-numeric: tabular-nums; }
  .dc-row-value small { margin-left: 5px; color: #8591a1; font-size: 11px; font-weight: 400; }
  .dc-row-arrow { color: #aebac7; font-size: 12px; }
  .dc-panel-footer { display: flex; align-items: center; gap: 6px; padding: 13px 20px; background: #fafcfd; border-top: 1px solid #edf1f5; font-size: 11px; color: #8190a1; }
  .dc-comparison-chart { padding: 24px 24px 18px; flex: 1; }
  .dc-comparison-item { display: block; width: 100%; margin-bottom: 23px; padding: 0; border: 0; background: transparent; }
  .dc-comparison-label { display: flex; justify-content: space-between; align-items: baseline; gap: 12px; margin-bottom: 11px; font-size: 12px; color: #627185; }
  .dc-comparison-label strong { font-size: 17px; font-weight: 600; color: #33465b; font-variant-numeric: tabular-nums; }
  .dc-bar-track { display: block; height: 9px; background: #f0f4f8; border-radius: 4px; overflow: hidden; }
  .dc-bar-fill { display: block; height: 100%; background: var(--accent); border-radius: 4px; }
  .dc-comparison-item:hover .dc-comparison-label { color: #188b84; }
  .dc-chart-scale { display: flex; justify-content: space-between; border-top: 1px solid #edf1f5; padding-top: 10px; color: #8b97a6; font-size: 10px; }
  .dc-comparison-note { display: flex; gap: 8px; margin: 0 20px 20px; padding: 12px; border-radius: 7px; background: #f5f8fb; font-size: 11px; line-height: 1.8; color: #7b8999; }
  .dc-comparison-note i { margin-top: 4px; }
  .dc-dashboard-footer { display: flex; justify-content: space-between; gap: 12px; margin-top: 20px; color: #8795a5; font-size: 11px; line-height: 1.6; }
}

@media (min-width: 1600px) {
  .dc-dashboard-container {
    padding: 32px;
    .dc-summary-card { padding: 26px 28px 20px; }
    .dc-summary-value { font-size: 44px; margin: 14px 0 22px; }
    .dc-metric-row { min-height: 100px; }
    .dc-comparison-item { margin-bottom: 31px; }
  }
}
@media (max-width: 1200px) {
  .dc-dashboard-container {
    padding: 20px;
    .dc-detail-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .dc-comparison-panel { grid-column: 1 / -1; }
    .dc-comparison-chart { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 20px 32px; }
    .dc-comparison-item { margin-bottom: 0; }
    .dc-chart-scale { grid-column: 1 / -1; }
    .dc-summary-card { padding: 16px; }
    .dc-summary-value { font-size: 32px; }
    .dc-icon-box { width: 38px; height: 38px; }
  }
}
@media (max-width: 760px) {
  .dc-dashboard-container {
    padding: 16px;
    .dc-dashboard-header { align-items: flex-start; flex-wrap: wrap; gap: 16px; }
    .dc-summary-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
    .dc-detail-grid { grid-template-columns: minmax(0, 1fr); gap: 16px; }
    .dc-panel-header { padding: 18px; }
    .dc-comparison-chart { display: block; }
    .dc-comparison-item { margin-bottom: 22px; }
    .dc-dashboard-footer { flex-direction: column; gap: 4px; }
  }
}
@media (max-width: 380px) {
  .dc-dashboard-container {
    .dc-summary-grid { grid-template-columns: minmax(0, 1fr); }
    .dc-row-icon { display: none; }
  }
}
@media (prefers-reduced-motion: reduce) {
  .dc-dashboard-container .dc-summary-card { transition: none; }
}
</style>
